import { service } from '../../api/axios';

export const markAllNotificationsAsRead = async () => {
  const response = await service.post<null>(
    '/notifications/mark-all-as-read',
    {}
  );
  return response.data;
};
